import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CTA_LABEL, OFFER_ANCHOR } from "../utils/checkout";
type CtaButtonProps = {
  /** Destino del botón. Por defecto, la sección de compra (#oferta). */
  href?: string;
  label?: string;
  className?: string;
};
export function CtaButton({
  href = OFFER_ANCHOR,
  label = CTA_LABEL,
  className = ""
}: CtaButtonProps) {
  const isAnchor = href.startsWith("#");
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (!isAnchor) return;
    const target = document.getElementById(href.slice(1));
    if (!target) return;
    e.preventDefault();
    const header = document.querySelector<HTMLElement>("header");
    const offset = header ? header.getBoundingClientRect().height : 0;
    const top = target.getBoundingClientRect().top + window.scrollY - offset;
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    window.scrollTo({
      top,
      behavior: reduce ? "auto" : "smooth"
    });
    window.history.replaceState(null, "", href);
  };
  return <a href={href} onClick={handleClick} className={`cta-btn group ${className}`} data-id="element-68" data-mp="35yz7759dtufr">
      <span className="cta-btn__label" data-id="element-69" data-mp="39z9k71vldl44">{label}</span>
      <ArrowRightIcon className="cta-btn__icon" aria-hidden="true" data-id="element-70" data-mp="3ey40nx636xl2" />
    </a>;
}